module.exports = __webpack_public_path__ + "svg/tick-blue.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/tick-blue.svg
// module id = 354
// module chunks = 8